import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let primary_location_id = useDataValue({
    context: 'profile_patient',
    path: 'primary_location._id',
    viewPath: props.viewPath,
  })

  return {
    variables: { primary_location_id },
  }
}
